<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                :disable-permission-checks="true"
                operations="add,edit,delete"
                ref="table">
      <template v-slot:created_at="{row}">
        <span>{{$formatDate(row.created_at, FRIENDLY_DATE_FORMAT)}}</span>
      </template>
    </data-table>
  </div>
</template>
<script>
  import { entities } from 'src/config/routeTypes'
  import PlaceholdersService from 'src/services/PlaceholdersService'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'
  import Badge from 'src/components/Badge'

  export default {
    name: 'placeholders-list',
    components: {
      Badge
    },
    data () {
      return {
        service: PlaceholdersService,
        entity: entities.PLACEHOLDER,
        FRIENDLY_DATE_FORMAT
      }
    },
    computed: {
      filters () {
        return [
          {
            key: 'match[job_board_id]',
            value: this.$route.params.id
          }
        ]
      },
      columns () {
        return [
          {
            prop: 'key',
            label: this.$t('placeholders.key'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'name',
            label: this.$t('placeholders.name'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'value',
            label: this.$t('placeholders.value'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '130px',
            sortable: true
          }
        ]
      },
      getSegmentById () {
        return this.$store.getters['config/getSegmentById']
      },
    },
  }
</script>
<style>
</style>
